import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PartSlider from "./PartSlider";
import Api from "../../../../../lib/Api";

class PartWeighing extends Component {
    constructor(props) {
        super(props);

        let toInt = (value) => parseInt(value || 0, 10);

        this.state = {
            chainRings: toInt(this.props.driveChainWeight),
            suspension: toInt(this.props.suspensionWeight),
            wheels: toInt(this.props.wheelsWeight),
            brakes: toInt(this.props.brakesWeight),
            guarantee: toInt(this.props.guaranteeWeight),
            weight: toInt(this.props.weightWeight),
            weightNotice: false
        };
    }

    componentDidMount() {
        if (this.isDefault()) {
            this.loadDefaultConfig();
        }
    }

    isDefault = () => {
        console.log((this.props.driveChainWeight || this.props.suspensionWeight || this.props.wheelsWeight || this.props.brakesWeight || this.props.guaranteeWeight || this.props.weightWeight || null) === "null");
        return (this.props.driveChainWeight || this.props.suspensionWeight || this.props.wheelsWeight || this.props.brakesWeight || this.props.guaranteeWeight || this.props.weightWeight || null) === null;
    }

    render() {
        let steps = {
            0: this.props.t('PartWeighing_Not'),
            1: this.props.t('PartWeighing_Less'),
            2: this.props.t('PartWeighing_Average'),
            3: this.props.t('PartWeighing_More'),
            4: this.props.t('PartWeighing_Priority')
        };
        return (
            <div className="container main">
                <form className="mt-4 part-weighing" onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-12 text-center title">
                            <h2>{this.props.t('PartWeighing_Title')}</h2>
                            <div className="sub-title">{this.props.t('PartWeighing_SubTitle')}</div>
                        </div>
                    </div>
                    <div className="row mb-5">
                        <div className="col-12">
                            <span className="slider-label">{this.props.t('PartWeighing_ChainRings')}</span>
                            <PartSlider value={this.state.chainRings} steps={steps} handle={(value) => {
                                this.setState({chainRings: value})
                            }} />
                        </div>
                    </div>

                    {this.props.traject === 'mtb' &&
                    <div className="row mb-5">
                        <div className="col-12">
                            <span className="slider-label">{this.props.t('PartWeighing_Suspension')}</span>
                            <PartSlider value={this.state.suspension} steps={steps} handle={(value) => {
                                this.setState({suspension: value})
                            }} />
                        </div>
                    </div>
                    }

                    {this.props.traject === 'race' &&
                    <div className="row mb-5">
                        <div className="col-12">
                            <span className="slider-label">{this.props.t('PartWeighing_Wheels')}</span>
                            <PartSlider value={this.state.wheels} steps={steps} handle={(value) => {
                                this.setState({wheels: value})
                            }} />
                        </div>
                    </div>
                    }

                    <div className="row mb-5">
                        <div className="col-12">
                            <span className="slider-label">{this.props.t('PartWeighing_Brake')}</span>
                            <PartSlider value={this.state.brakes} steps={steps} handle={(value) => {
                                this.setState({brakes: value})
                            }} />
                        </div>
                    </div>

                    <div className="row mb-5">
                        <div className="col-12">
                            <span className="slider-label">{this.props.t('PartWeighing_Guarantee')}</span>
                            <PartSlider value={this.state.guarantee} steps={steps} handle={(value) => {
                                this.setState({guarantee: value})
                            }} />
                        </div>
                    </div>

                    <div className="row mb-5">
                        <div className="col-12">
                            <span className="slider-label">{this.props.t('PartWeighing_Weight')}</span>
                            <PartSlider value={this.state.weight} steps={steps} handle={(value) => {
                                if (this.state.weight === 0 && value !== 0) {
                                    this.showWeightNotice();
                                } else if(value === 0) {
                                    this.forceHideWeightNotice();
                                }
                                this.setState({weight: value})
                            }} />
                            <div className={this.state.weightNotice ? "text-center weight-notice" : "text-center weight-notice hidden"}>
                                {this.props.t('PartWeighing_WeightNotice')}
                            </div>
                        </div>
                    </div>

                    <div className="row button-row">
                        <div className="col-6 text-left">
                            <button className="back btn btn-link" onClick={this.goBack}><i
                                className="fas fa-caret-left" /> {this.props.t('Terug naar vorige stap')}</button>
                        </div>
                        <div className="col-6 text-right">
                            <input className="btn btn-default" type="button" onClick={this.submitDefaultConfig}
                                   value={this.props.t('PartWeighing_ReloadDefaults')}/>
                            <input className="btn btn-secondary" type="submit"
                                   value={this.props.t('Apply')}/>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    showWeightNotice = () => {
        this.setState({'weightNotice': true});
        setTimeout(() => { this.setState({'weightNotice': false}); }, 10000);
    };

    forceHideWeightNotice = () => {
        // alert(this.props.t('PartWeighing_WeightNotice'));
        this.setState({'weightNotice': false});
    };

    goBack = (e) =>  {
        e.preventDefault();
        this.props.goTo('/advice/result', this.props.traject);
    };

    loadDefaultConfig = (afterCallback) => {
        let bike_cat = 'MTB';
        if (this.props.traject === 'race') {
            bike_cat = 'Race';
        }

        let inputData = {
            bike_cat: bike_cat,
            speed: this.props.speed,
            position: this.props.filterPosition,
            image: this.props.image,
            experience: this.props.experience,
            parcour_type: this.props.parcourType,
            usage: this.props.usage,
            suspension: this.props.suspension,
            gents_ladies: this.props.sex,
            max_price: this.props.price,
            weight: this.props.weight,
            length: this.props.length,
            inner_leg_length: this.props.inner_leg,
            torso: this.props.romp,
            age: this.props.age,
            arm: this.props.arm,
            shoe: this.props.shoe_size,
            upper_leg: 0
        };

        Api.get('/weightingfactors', inputData).then(response => {
            let toInput = (value) => parseInt(value, 10);
            this.setState({
                chainRings: toInput(response.data.data.drive_chain),
                suspension: toInput(response.data.data.suspension),
                wheels: toInput(response.data.data.wheels),
                brakes: toInput(response.data.data.brakes),
                guarantee: toInput(response.data.data.guarantee),
                weight: toInput(response.data.data.weight)
            });
        });
    };

    submitDefaultConfig = () => {
        this.props.setPartWeighing(
            null,
            null,
            null,
            null,
            null,
            null
        ).then(() => this.props.goTo('/advice/result', this.props.traject));
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.setPartWeighing(
            this.state.chainRings,
            this.state.suspension,
            this.state.wheels,
            this.state.brakes,
            this.state.guarantee,
            this.state.weight
        ).then(() => this.props.goTo('/advice/result', this.props.traject));
    }
}

export default withTranslation('result')(PartWeighing);